import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import axios from "../../../axios";

export const getMyCart = () => ({ type: "GET_MY_CART" })
export const getMyCartRequest = () => ({ type: "GET_MY_CART_REQUEST" })
export const getMyCartSuccess = payload => ({ type: "GET_MY_CART_SUCCESS", payload })
export const getMyCartFailed = error => ({ type: "GET_MY_CART_FAILED", error })

export function* getMyCartSaga() {
    yield put(getMyCartRequest())
    try {
        let { data: payload } = yield call(axios,"/me/cart")
        yield put(getMyCartSuccess(payload))
    } catch(err){
        yield put(getMyCartFailed(err))
    }
}

export const removeFromCart = ({ line_item_id }) => ({ type: "REMOVE_FROM_CART", line_item_id })
export const removeFromCartRequest = () => ({ type: "REMOVE_FROM_CART_REQUEST" })
export const removeFromCartSuccess = payload => ({ type: "REMOVE_FROM_CART_SUCCESS", payload })
export const removeFromCartFailed = error => ({ type: "REMOVE_FROM_CART_FAILED", error })

export function* removeFromCartSaga({ 
    line_item_id
}) {
    yield put(removeFromCartRequest())
    try {
        let { data: payload } = 
            yield call(axios,{ 
                data: { line_item_id }, 
                url: "/me/cart/remove/item", 
                method: "post" 
            })
        yield put(removeFromCartSuccess(payload))
    } catch(err){
        yield put(removeFromCartFailed(err))
    }
}

export const addFloorBoxesToCart = ({ FloorId, FloorTileSizeId, boxes_amount, mil_type, variation_id, onStart, onSuccess, onError }) => 
        ({ type: "ADD_FLOOR_BOXES_TO_CART", FloorId, FloorTileSizeId, boxes_amount, mil_type, variation_id, onStart, onSuccess, onError })
export const addFloorBoxesToCartRequest = () => ({ type: "ADD_FLOOR_BOXES_TO_CART_REQUEST" })
export const addFloorBoxesToCartSuccess = payload => ({ type: "ADD_FLOOR_BOXES_TO_CART_SUCCESS", payload })
export const addFloorBoxesToCartFailed = error => ({ type: "ADD_FLOOR_BOXES_TO_CART_FAILED", error })

export function* addFloorBoxesToCartSaga({ 
    FloorId, FloorTileSizeId, boxes_amount, mil_type, 
    onSuccess, onStart, onError, variation_id
}) {
    yield call(onStart)
    yield put(addFloorBoxesToCartRequest())
    try {
        let { data: payload } = 
            yield call(axios,{ 
                data: { FloorId, FloorTileSizeId, boxes_amount, mil_type, variation_id }, 
                url: "/me/cart/add/floor_boxes", 
                method: "post" 
            })
        yield put(addFloorBoxesToCartSuccess(payload))
        yield call(onSuccess)
    } catch(err){
        yield call(onError)
        yield put(addFloorBoxesToCartFailed(err))
    }
}

export const discardCart = () => ({ type: "DISCARD_CART" })
export const discardCartRequest = () => ({ type: "DISCARD_CART_REQUEST" })
export const discardCartSuccess = payload => ({ type: "DISCARD_CART_SUCCESS", payload })
export const discardCartFailed = error => ({ type: "DISCARD_CART_FAILED", error })
export function* discardCartSaga({ onSuccess, onStart,  onError }) {
    if (onStart) yield call(onStart)
    yield put(discardCartRequest())
    try {
        let { data: payload } = yield call(axios, {
            url: "/me/cart/discard",
            method: "post"
        })
        yield put(discardCartSuccess(payload))
        if (onSuccess) yield call(onSuccess)
    } catch(err){
        if (onError) yield call(onError)
        yield put(discardCartFailed(err))
    }
}

export const reviewFloor = ({ FloorId, description, value }) => ({ type: "REVIEW_FLOOR", FloorId, description, value })
export const reviewFloorRequest = () => ({ type: "REVIEW_FLOOR_REQUEST" })
export const reviewFloorSuccess = payload => ({ type: "REVIEW_FLOOR_SUCCESS", payload })
export const reviewFloorFailed = error => ({ type: "REVIEW_FLOOR_FAILED", error })
export function* reviewFloorSaga({ FloorId, description, value, onSuccess, onStart,  onError }) {
    if (onStart) yield call(onStart)
    yield put(reviewFloorRequest())
    try {
        let { data: payload } = yield call(axios, {
            url: "/me/review/floor/" + FloorId,
            method: "post",
            data: { description, value } 
        })
        yield put(reviewFloorSuccess(payload))
        if (onSuccess) yield call(onSuccess)
    } catch(err){
        if (onError) yield call(onError)
        yield put(reviewFloorFailed(err))
    }
}

export const guest_to_standard_user = ({ 
    email, password, first_name, last_name,
    phone, address, onStart, onSuccess, onError
}) => ({
    type: "GUEST_TO_STANDARD_USER",
    email, password, first_name, last_name,
    phone, address, onStart, onSuccess, onError
})
export const guest_to_standard_user_request = () => ({ 
    type: "GUEST_TO_STANDARD_USER_REQUEST"
})
export const guest_to_standard_user_success = payload => ({ type: "GUEST_TO_STANDARD_USER_SUCCESS", payload })
export const guest_to_standard_user_failed = error => ({ type: "GUEST_TO_STANDARD_USER_FAILED", error })
export function* guest_to_standard_user_saga({
    email, password, first_name, last_name,
    phone, address, onStart, onSuccess, onError
}) {
    if (onStart) yield call(onStart)
    yield put(guest_to_standard_user_request())
    try {
        let { data: payload } = yield call(axios, {
            url: "/me/checkout/guest_to_standard_user?err_per_field=1",
            method: "post",
            data: {
                email, password, first_name, last_name,
                phone, address
            }
        })
        yield put(guest_to_standard_user_success(payload))
        if (onSuccess) yield call(onSuccess)
    } catch(err){
        if (onError) yield call(onError)
        yield put(guest_to_standard_user_failed(err))
    }
}

export default function* meSageWatcher() {
    yield takeEvery("GET_MY_CART", getMyCartSaga)
    yield takeEvery("REMOVE_FROM_CART", removeFromCartSaga)
    yield takeEvery("ADD_FLOOR_BOXES_TO_CART", addFloorBoxesToCartSaga)
    yield takeEvery("DISCARD_CART", discardCartSaga)
    yield takeEvery("REVIEW_FLOOR", reviewFloorSaga)
    yield takeEvery("GUEST_TO_STANDARD_USER", guest_to_standard_user_saga)
}